import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { projectFirestore } from "components/ProjectFirestore";
import Link from "next/link";

import DataAnalysisApp from "./DataAnalysisApp";

import AppTitle from "pages/user/market/appDetailMenu/appTitle";
import AppPreview from "pages/user/market/appDetailMenu/appPreview";
import AppContent from "pages/user/market/appDetailMenu/appContent";
import AppRunBasic from "pages/user/market/appDetailMenu/appRun/Basic";
import AppRunCustom from "pages/user/market/appDetailMenu/appRun/Custom";
import AppLicense from "pages/user/market/appDetailMenu/appLicense";

import firebase from "firebase/app";
import SEO from "components/SEO";

const AppPages = ({ headUrl, headTitle, headDesc }) => {
  const router = useRouter();
  const [data, setData] = useState(null);

  useEffect(async () => {
    const { id } = router.query;

    if (id) {
      try {
        const publicDocRef = projectFirestore.collection("market").doc("public").collection("app").doc(id);
        const privateDocRef = projectFirestore.collection("market").doc("private").collection("app").doc(id);

        const publicValue = await publicDocRef.get();
        if (publicValue.exists) {
          setData(publicValue.data());
        } else {
          const privateValue = await privateDocRef.get();
          if (privateValue.exists) {
            setData(privateValue.data());
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [router]);

  if (data) {
    if (data.category === "dataAnalysis") {
      return (
        <div>
          <DataAnalysisApp
            email={data.email}
            appId={data.appId}
            appName={data.appName}
            inputFile={data.inputFile}
            target={data.target}
            csvInfo={data.csvInfo}
            outputJson={data.outputJson}
            outputHtml={data.outputHtml}
            outputMatrix={data.outputMatrix ? data.outputMatrix : ""}
          />
        </div>
      );
    } else {
      return (
        <div className="w-full">
          <SEO url={headUrl} title={headTitle} desc={headDesc} />
          <div className="w-full">
            <div className="page-content w-full pt-12 pb-36">
              <div className="aiso-card shadow-md">
                {/* <AppHeader {...data} /> */}
                {/* 앱 이름 & 가격 */}
                <AppTitle appName={data.appName} price={data.price} />
                {/* 앱 샘플 파일 나타내기 */}
                <AppPreview {...data} />
                {/* 앱 설명 */}
                <AppContent content={data.content} />
                {/* LICENSE 표시 */}
                <AppLicense {...data} />
                {/* 앱 실행 공간 */}
                {data.type === "custom" ? <AppRunCustom {...data} /> : <AppRunBasic {...data} />}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  return (
    <div className="w-full flex justify-center items-center" style={{ width: "100%", minHeight: "100vh" }}>
      <div className="mr-4">
        <div className="loader-demo-box2 mt-2">
          <div className="dot-opacity-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <div>
        <div>잠시만 기다려주세요...</div>
        <Link
          href={{
            pathname: "/user/market",
          }}
        >
          <button type="" className="btn btn-info text-xs font-bold px-3 py-2 mr-3 mt-4">
            AISO 로 이동하기
          </button>
        </Link>
      </div>
    </div>
  );
};

AppPages.getInitialProps = async ({ asPath, query }) => {
  const { id } = query;

  let headTitle = "아이소";
  let headDesc = "인공지능 마켓, 아이소 입니다.";
  const headUrl = `https://aiso.ai${asPath}`;

  try {
    const publicDocRef = firebase.firestore().collection("market").doc("public").collection("app").doc(id);
    const privateDocRef = firebase.firestore().collection("market").doc("private").collection("app").doc(id);

    const publicValue = await publicDocRef.get();
    if (publicValue.exists) {
      headTitle = publicValue.data().appName;
      headDesc = publicValue.data().oneLineContent;
    } else {
      const privateValue = await privateDocRef.get();
      if (privateValue.exists) {
        headTitle = privateValue.data().appName;
        headDesc = privateValue.data().oneLineContent;
      }
    }
  } catch (error) {
    console.error(error);
  }

  return { headUrl, headTitle, headDesc };
};
export default AppPages;
